import type {
  GetReviewsResponseReview,
  GetReviewsResponseWithStatistics,
  GetReviewStatisticsResponse,
} from '@integration/api-client/reviews';

export const mockStatistics: GetReviewStatisticsResponse = {
  averageRating: 8,
  recommendPercentage: 75,
  totalReviews: 1000,
};

export const mockReview: GetReviewsResponseReview = {
  id: 'd17e6d87-2dbd-4bf1-bcb5-ab86a3147903',
  author: 'Michael ',
  city: 'Althoff',
  date: '2022-05-01T18:00:10.976Z',
  content:
    'Heel schlechte klantenservice, telefoon wordt gewoon neergelegd als zij geen goede antwoord hebben.\nProbleem ligt nooit bei Essent.',
  title: 'Mock review 1',
  wouldRecommend: false,
  rating: 2,
};

export const mockReviewsWithStatistics: GetReviewsResponseWithStatistics = {
  reviews: [mockReview, mockReview, mockReview, mockReview],
  ...mockStatistics,
};
